import { render } from "./GroupPanel.vue?vue&type=template&id=6ab6d576&scoped=true"
import script from "./GroupPanel.vue?vue&type=script&lang=js"
export * from "./GroupPanel.vue?vue&type=script&lang=js"

import "./GroupPanel.vue?vue&type=style&index=0&id=6ab6d576&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab6d576"]])

export default __exports__